
    import { Vue, Component, Prop } from "vue-property-decorator";
  
    @Component
    export default class CustomisedRequestCard extends Vue {
      @Prop({ type: String, default: undefined }) readonly footerPadding?: string;
      @Prop({ type: Boolean, default: false }) readonly elasticActionBar!: boolean;
      @Prop({ type: Boolean, default: false }) readonly warning!: boolean;
      @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
  
      get padding(): string {
        return this.footerPadding ? this.footerPadding : "";
      }
  
      get actionBarStyles(): object {
        return {
          "h-10": !this.elasticActionBar,
          "px-4": !this.footerPadding,
          [this.padding]: Boolean(this.padding),
        };
      }
  
      get bgClasses(): object {
        return {
          "bg-yellow-50": this.warning,
        };
      }
  
      get optionalClasses(): Record<string, boolean> {
        return {
          ["bg-gray-200 text-gray-500"]: this.disabled,
        }
      }
    }
  
  